module.exports = function namespacesToMethodAccess(namespaces, userAccess) {
    return namespaces.map((ns, j) => ({
        title: ns.title,
        prettyName: ns.prettyName,
        relations: ns.relations.map((rel, i) => ({
            title: rel.title,
            prettyName: rel.prettyName,
            withCustomRepository: false,
            blockId: `OghVr)dP:AIDS[zF-${j}-${i}`,
            limitSyncSize: false,
            methodAccess: [
                {
                    role: 'USER',
                    remove: true,
                    get: true,
                    patch: true,
                    post: true,
                    ...userAccess
                },
                {
                    role: 'DEITY',
                    get: true,
                    patch: true,
                    post: true,
                    put: true,
                    remove: true
                }
            ]
        })),
        blockId: `)sEcMUw}b]?+,!Jd-${j}`,
        withCustomApi: false,
        hideApiDocs: false
    }));
};
